import axios from 'axios';
import { invalidateListingAppointmentConfigCache } from './getListingAppointmentConfig';

type DeleteConfigContactParams = {
  listingId: string;
  contactId: string;
};

const deleteConfigContact = async (params: DeleteConfigContactParams) => {
  const { data } = await axios.post(
    `/appointments/${params.listingId}/config/contacts/deleteContact/${params.contactId}`,
  );

  invalidateListingAppointmentConfigCache(params.listingId);

  return data;
};

export default deleteConfigContact;
